angular.module("myApp").config(($provide) =>
  $provide.decorator("$state", ($delegate, $rootScope) => {
    $delegate.orig_go = $delegate.go
    $delegate.go = (to, params, opts) => {
      const para = params || {}
      para.context = $rootScope.u.context || "nocontext"
      return $delegate.orig_go(to, para, opts)
    }
    return $delegate
  })
)
